module.exports = __webpack_public_path__ + "static/media/okFace.07977dc4.svg";